import { ESignPartyItemAccordion } from 'app/domains/esigning/components/ESignPartyItemAccordion';
import { SectionListItem } from 'app/domains/esigning/components/components';
import { FormDefaultSignatoryActions } from './FormDefaultSignatoryActions';
export function FormDefaultSignatoryItem(props) {
    const { signatory } = props;
    const { firstName, lastName, email, label, title, authenticationMode, isSigning, mobile } = signatory;
    const signatoryName = `${firstName} ${lastName}`;
    return (<SectionListItem primary={signatoryName} secondary={email} endElement={<FormDefaultSignatoryActions signatory={signatory}/>} accordionElement={<ESignPartyItemAccordion email={email} title={title} mobile={mobile} label={label} isSigning={isSigning} authenticationMode={authenticationMode}/>}/>);
}
